<script>
export default {
    name: "Stamp",
    data(){
        return{
            companyUrl:this.$root.companydetails.stampUrl,
        }
    }
}
</script>
<template>
    <div class="w-full -mt-10" >
        <div class="flex items-center justify-end mr-10 pb-2" ><img :src="companyUrl"></div> 

    </div>
    
</template>


